import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { homeApi } from "../slices/pageSlice";
import { createPageApi } from "../slices/pageSlice"; // Import the createPageApi from your slice
import { createReportApi } from "../slices/reportSlice";
import { deleteAccountApi } from "../slices/AccountSlice";
import { verifyOtpApi } from "../slices/AccountSlice";
import { deleteUserApi } from "../slices/AccountSlice";
import { createEmailSubscribeApi } from "../slices/emailSubscribeSlice";
import modalReducer from "../slices/modelSlice";
import colorReducer from "../slices/backgroundColor";
export const store = configureStore({
  reducer: {
    [homeApi.reducerPath]: homeApi.reducer,
    [createPageApi.reducerPath]: createPageApi.reducer, // Add the createPageApi reducer
    [createReportApi.reducerPath]: createReportApi.reducer,
    [createEmailSubscribeApi.reducerPath]: createEmailSubscribeApi.reducer,
    [deleteAccountApi.reducerPath]: deleteAccountApi.reducer,
    [verifyOtpApi.reducerPath]: verifyOtpApi.reducer,
    [deleteUserApi.reducerPath]: deleteUserApi.reducer,
    modal: modalReducer,
    color: colorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      homeApi.middleware,
      createPageApi.middleware,
      createReportApi.middleware,
      createEmailSubscribeApi.middleware,
      deleteAccountApi.middleware,
      verifyOtpApi.middleware,
      deleteUserApi.middleware
    ), // Add the middleware for both API slices
});

setupListeners(store.dispatch);
